/*eslint-disable no-undef */
import phina from 'phina.js'

export default ()=>{

/**
 * 波紋
 */
phina.define('WaveEffect', {
  superClass: 'phina.display.Shape',
  init: function(param){
    param = (param||{}).$safe(WaveEffect.defaults);
    this.superInit(param);

    this.eff = phina.display.CircleShape({
      backgroundColor: 'transparent',
      fill: 'transparent',
      stroke: '#FFF',
      strokeWidth: 10,
      radius: param.width,
    }).addChildTo(this).tweener
      .clear()
      .to({radius:param.width*4, alpha:0}, 750, 'easeOutCubic')
      .call(()=>{ this.remove() });
  },
  _static: {
    defaults: {
      fill: 'transparent',
      stroke: 'transparent',
      backgroundColor: 'transparent',
      width:64, 
    },
  },
});

/**
 * 振動
 */
phina.define('ShakeEffect', {
  superClass: 'phina.accessory.Accessory',
  /**
   * @constructor
   */
  init: function(target) {
    this.superInit(target);

    this.on('attached', function() {
      var self=this;
      this.target.shake = this.target.shake||{x:this.target.x, y:this.target.y};
      this.target.tweener
        .clear()
        .moveBy(Math.randint(-5,5),Math.randint(-10,10),20)
        .moveBy(Math.randint(-5,5),Math.randint(-10,10),20)
        .moveBy(Math.randint(-5,5),Math.randint(-10,10),20)
        .moveBy(Math.randint(-5,5),Math.randint(-10,10),20)
        .moveBy(Math.randint(-5,5),Math.randint(-10,10),20)
        .moveTo(self.target.shake.x,self.target.shake.y,10)
        .call(function(){
          self.target.shake = null;
          self.remove();
        });
    });
  },

  update: function(){
  },

  cancel: function() {
  },

  enable: function() {
    this._enable = true;
  },

});

/**
 * 点灯
 */
phina.define('FlashEffect', {
  superClass: 'phina.display.RectangleShape',
  init: function(param){
    param = (param||{}).$safe(FlashEffect.defaults);
    this.superInit(param);

    this.fromJSON({blendMode:'hard-light'})
    .tweener
      .clear()
      .to({alpha:0.0}, 1000, 'easeInQuint')
      .call(()=>{ this.remove() });
  },
  _static: {
    defaults: {
      fill: '#FFF',
      stroke: 'transparent',
      backgroundColor: 'transparent',
    },
  },
});


}